export const LOCATION_PICK_COLOR_ICON = '#008C00';
export const LOCATION_DROP_COLOR_ICON = '#CC0000';
export const LOCATION_VIA_COLOR_ICON = '#FF7400';
export const MAP_CAR_COLOR_ICON = '#4096EE';
export const WHITE_COLOR = '#ffffff';
export const BLACK_COLOR = '#000000';

export const BUTTON_COLOR = '#CC0000';
export const BUTTON_TEXT_COLOR = '#ffffff';

export const PENDING_COLOR = '#4096EE';
export const COMPLETED_COLOR = '#008C00';
export const CANCEL_COLOR = '#FF7400';
export const PAYMENT_COLOR = '#CC0000';

export const ONLINE_COLOR = '#CC0000';
export const GRAY_COLOR = '#999999';
export const GRAY_LIGHT_COLOR = '#dddddd';
export const INPUT_COLOR = '#444444';
export const STAR_YELLOW = '#ff9529';
export const SELECTED_COLOR = '#f2a5a3';

// Fleet live-status legend (TENANT_AGENCY_MODULE.md §5.3). These map onto
// a_customer_locations.status ENUM('active','inactive','busy','idle').
export const FLEET_ACTIVE_COLOR = '#008C00';   // online, free to take work
export const FLEET_BUSY_COLOR = '#FF7400';     // on a job
export const FLEET_IDLE_COLOR = '#4096EE';     // online, not working
export const FLEET_OFFLINE_COLOR = '#999999';  // offline / no location row

// Where a fare goes — Dashboard and Payments. Order matters (adjacent in the
// split bar); validated as a categorical set on white: CVD ΔE ≥ 13, contrast ≥ 3:1.
export const MONEY_DRIVER_COLOR = '#2563EB';        // drivers' share / net
export const MONEY_SUPPLIER_COLOR = '#D97706';      // the supplier's commission
export const MONEY_LICENSED_TAXI_COLOR = '#CC0000'; // LicensedTaxi charges
export const MONEY_THIRD_PARTY_COLOR = '#6D28D9';   // agent / corporate commission
// Single-series trend (fares per day): neutral so it doesn't read as one of the above.
export const TREND_COLOR = '#475569';
